import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";

import successAnim from "../animations/success.json";
import goodAnim from "../animations/good.json";
import failAnim from "../animations/fail.json";

function EssayLayout({
  title,
  subject,
  teacher,
  questions = [],
  essayType,
  setEssayType,
  timeLeft,
  onAnswer,
  answers = {},
  onSubmit,
  onContinue = () => {},
  onRetry,
  onReview,
  submitted = false,
  submitting = false,
  historyReviewMode = false,
  score = 0,
  showPremium = false,
  showContinue = true
}) {

  const navigate = useNavigate();
  const isReviewMode = historyReviewMode;
  const formatTime = (time) => {

    if (typeof time !== "number")
      return time;

    const m = Math.floor(time / 60);
    const s = time % 60;

    return `${m
      .toString()
      .padStart(2, "0")} : ${s
      .toString()
      .padStart(2, "0")}`;

  };

  useEffect(() => {

    const style =
      document.createElement("style");

    style.innerHTML = `

      @keyframes popupScale {

        from {

          transform: scale(0.6);
          opacity: 0;

        }

        to {

          transform: scale(1);
          opacity: 1;

        }

      }

      @keyframes confetti {

        0% {

          transform:
            translateY(-100vh)
            rotate(0deg);

        }

        100% {

          transform:
            translateY(100vh)
            rotate(360deg);

        }

      }

      .confetti {

        position: fixed;

        width: 8px;

        height: 8px;

        top: 0;

        animation:
          confetti 2s linear infinite;

        z-index: 9999;

      }

    `;

    document.head.appendChild(style);

    return () => {

      document.head.removeChild(style);

    };

  }, []);

  const renderConfetti = () => {

    return Array.from({
      length: 40
    }).map((_, i) => (

      <div
        key={i}
        className="confetti"
        style={{

          left:
            Math.random() *
              100 +
            "%",

          background: [

            "#22c55e",
            "#3b82f6",
            "#f59e0b",
            "#ef4444"

          ][i % 4],

          animationDelay:
            Math.random() *
              2 +
            "s"

        }}
      />

    ));

  };

  return (

    <div style={pageWrapper}>

      <div style={page}>

        {/* PAPER TYPE */}

        <div style={paperTypeBox}>

          <label style={radioLabel}>

           <input
             type="radio"
             value="model_papers"
             checked={essayType === "model_papers"}
             disabled={historyReviewMode}
             onChange={() => setEssayType("model_papers")}
           />

            {" "}Model Papers

          </label>

          <label style={radioLabel}>

            <input
              type="radio"
              value="past_papers"
              checked={essayType === "past_papers"}
              disabled={historyReviewMode}
              onChange={() => setEssayType("past_papers")}
            />

            {" "}Past Papers

          </label>

        </div>

        {/* LOGO */}

        <div style={logoBox}>

          <img
            src="/logo2.png"
            alt="logo"
            style={logo}
          />

        </div>

        {/* HEADER */}

        <div style={examInfoBox}>

          <div style={infoTop}>

            <div>

              <h2>{title}</h2>

              <p>

                <b>Subject:</b>{" "}
                {subject || "-"}

                <br />

                <b>Teacher:</b>{" "}
                {teacher || "-"}

              </p>

            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >

              {isReviewMode && (

                <button
                  style={closeBtn}
                  onClick={() =>
                    navigate("/profile")
                  }
                >
                  ✕ Close
                </button>

              )}

              <div style={timerBox}>

                ⏱️ {formatTime(timeLeft)}

              </div>

            </div>

          </div>

        </div>

        {/* QUESTIONS */}

        <div style={examPaper}>

          {questions.map((q, i) => {

            const answer = answers[q.essay_id] || {};

            const userAnswer = isReviewMode
              ? (answer.student_answer || "")
              : (answers[q.essay_id] || "");

            const correctAnswer = answer.teacher_answer || "";
            const isCorrect = answer.correct || false;
            const reason = answer.reason || "";


            return (

              <div
                key={q.essay_id}
                style={{
                  marginBottom: 25
                }}
              >

                <h4>
                  {i + 1}. {q.title}
                </h4>

                <p
                  style={{
                    marginTop: "10px",
                    marginBottom: "15px"
                  }}
                >
                  {q.question}
                </p>

                {!isReviewMode && (

                  <textarea
                    value={userAnswer}
                    onChange={(e) =>
                      onAnswer(q.essay_id, e.target.value)
                    }
                    placeholder="Write your answer here..."
                    style={textareaStyle}
                  />

                )}

                {isReviewMode && (

                  <div style={{ marginTop: "20px" }}>

                    <div
                      style={{
                        background: isCorrect ? "#dcfce7" : "#fee2e2",
                        border: `2px solid ${
                          isCorrect ? "#22c55e" : "#ef4444"
                        }`,
                        padding: "15px",
                        borderRadius: "12px",
                        marginBottom: "12px"
                      }}
                    >

                      <b>
                        {isCorrect ? "✅ Correct" : "❌ Wrong"}
                      </b>

                    </div>

                    <div
                      style={{
                        background: "#dbeafe",
                        padding: "15px",
                        borderRadius: "12px",
                        marginBottom: "12px"
                      }}
                    >

                      <b>📝 Your Answer</b>

                      <p style={{ marginTop: "10px" }}>
                        {userAnswer || "No Answer"}
                      </p>

                    </div>

                    <div
                      style={{
                        background: "#dcfce7",
                        padding: "15px",
                        borderRadius: "12px",
                        marginBottom: "12px"
                      }}
                    >

                      <b>✅ Correct Answer</b>

                      <p style={{ marginTop: "10px" }}>
                        {correctAnswer || "No Correct Answer"}
                      </p>

                    </div>

                    {reason && (

                      <div
                        style={{
                          background: "#f3f4f6",
                          padding: "15px",
                          borderRadius: "12px"
                        }}
                      >

                        <b>💡 AI Feedback</b>

                        <p style={{ marginTop: "10px" }}>
                          {reason}
                        </p>

                      </div>

                    )}

                  </div>

                )}

              </div>

            );

          })}

          {!submitted && !isReviewMode && (

            <div
              style={{
                textAlign: "right"
              }}
            >

              <button
                  style={{
                      ...submitBtn,
                      opacity: submitting ? 0.7 : 1,
                      cursor: submitting ? "not-allowed" : "pointer"
                  }}
                  onClick={onSubmit}
                  disabled={submitting}
              >
                  {submitting ? "Checking..." : "🚀 Submit"}
              </button>

            </div>

          )}

        </div>

      </div>


      {/* RESULT POPUP */}

      {submitted &&
        !isReviewMode &&
        (() => {

          const total = questions.length;

          const percent =
            total > 0
              ? Math.round((score / total) * 100)
              : 0;

          let message = "";
          let color = "#22c55e";
          let animation = successAnim;
          let sound = "/sound/success.mp3";

          // ================= PERFECT =================

          if (percent >= 100) {

            message =
              "Perfect! You nailed it!";

            color = "#22c55e";

            animation = successAnim;

            sound =
              "/sound/success.mp3";

          }

          // ================= GOOD =================

          else if (percent >= 60) {

            message =
              "Good job! Keep going!";

            color = "#f59e0b";

            animation = goodAnim;

            sound =
              "/sound/good.mp3";

          }

          // ================= FAIL =================

          else {

            message =
              "Oops! Try again!";

            color = "#ef4444";

            animation = failAnim;

            sound =
              "/sound/fail.mp3";

          }

          return (

            <div style={overlayUltra}>

              <audio
                key={sound}
                src={sound}
                autoPlay
              />

              {percent >= 100 &&
                renderConfetti()}

              <div style={popupUltra}>

                <div style={topUltra}>

                  <Lottie
                    animationData={
                      animation
                    }
                    loop={true}
                    style={{
                      height: 140
                    }}
                  />

                </div>

                <h2 style={titleUltra}>

                  Your Result

                </h2>

                <h1
                  style={{
                    fontSize: "48px",
                    color,
                    margin: "10px 0",
                    fontWeight: "bold"
                  }}
                >

                  {score} / {total}

                </h1>

                <p style={messageUltra}>

                  {message}

                </p>

                <>
                  {showContinue && (

                    <button
                      style={btnUltra}
                      onClick={onContinue}
                    >
                      Continue →
                    </button>

                  )}

                  <button
                    type="button"
                    style={{
                      ...btnUltra,
                      marginTop: "10px",
                      background:
                        "linear-gradient(135deg,#3b82f6,#2563eb)"
                    }}
                    onClick={onReview}
                  >
                    📄 Review Paper
                  </button>

                  <button
                    style={retryBtn}
                    onClick={onRetry}
                  >
                    🔄 Try Again
                  </button>
                </>

              </div>

            </div>

          );

        })()}

        {/* PREMIUM POPUP */}

        {showPremium && (

          <div style={premiumOverlay}>

            <div style={premiumCard}>

              <h2
                style={{
                  fontSize: "34px",
                  marginBottom: "15px",
                  fontWeight: "bold"
                }}
              >
                🔒 Premium Essay
              </h2>

              <p
                style={{
                  lineHeight: "1.8",
                  color: "#555",
                  marginBottom: "25px"
                }}
              >
                More Essay attempts require payment access.
              </p>

              <button
                style={premiumBtn}
                onClick={() => {

                  const user = JSON.parse(
                    localStorage.getItem("user") || "null"
                  );

                  if (!user?.id) {

                    localStorage.setItem(
                      "redirect_after_login",
                      "/profile"
                    );

                    navigate("/auth");
                    return;
                  }

                  navigate("/profile");

                }}
              >
                🔓 Unlock Now
              </button>

            </div>

          </div>

        )}

        {/* LOADING OVERLAY */}

        {submitting && (

          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.7)",
              backdropFilter: "blur(8px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 20000
            }}
          >

            <div
              style={{
                background: "#fff",
                padding: "30px",
                borderRadius: "20px",
                textAlign: "center",
                minWidth: "320px"
              }}
            >

              <h2>🤖 AI is checking your answers...</h2>

              <p>Please wait...</p>

            </div>

          </div>

        )}

      </div>

    );

  }

export default EssayLayout;




/* ================= STYLES ================= */

const pageWrapper = {
  minHeight: "100vh",
  background:"linear-gradient(135deg,#0f172a,#020617)",
  display: "flex",
  justifyContent: "center",
  padding: "40px 15px"

};

const page = {
  width: "100%",
  maxWidth: "900px"

};

const paperTypeBox = {
  background: "#fff",
  padding: "15px",
  borderRadius: "18px",
  marginBottom: "20px",
  display: "flex",
  justifyContent: "center",
  gap: "30px",
  flexWrap: "wrap"

};

const radioLabel = {
  fontSize: "18px",
  fontWeight: "500",
  cursor: "pointer"

};

const logoBox = {
  textAlign: "center",
  marginBottom: "15px"

};

const logo = {
  width: "90px"
};

const examInfoBox = {
  background: "#fff",
  padding: "25px",
  borderRadius: "18px",
  marginBottom: "25px"

};

const infoTop = {
  display: "flex",
  justifyContent: "space-between"

};

const timerBox = {
  border: "2px solid #000",
  padding: "8px 14px",
  borderRadius: "8px"

};

const examPaper = {
  background: "#fff",
  padding: "35px",
  borderRadius: "20px"

};

const textareaStyle = {

  width: "100%",
  minHeight: "180px",
  padding: "15px",
  marginTop: "15px",
  borderRadius: "12px",
  border: "1px solid #ccc",
  resize: "vertical"

};

const submitBtn = {

  padding: "14px 35px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: "12px",
  cursor: "pointer"

};

const overlayUltra = {

  position: "fixed",
  inset: 0,
  background:"rgba(0,0,0,0.85)",
  backdropFilter:"blur(12px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999

};

const popupUltra = {

  width: "380px",
  padding: "80px 30px 30px",
  borderRadius: "30px",
  textAlign: "center",
  background:"linear-gradient(135deg,#1e293b,#020617)",
  color: "#fff",
  position: "relative",
  animation:"popupScale 0.35s ease"

};

const topUltra = {
  position: "absolute",
  top: "-60px",
  left: "50%",
  transform:"translateX(-50%)"

};

const titleUltra = {
  marginTop: "20px"

};

const messageUltra = {
  marginBottom: "20px"

};

const btnUltra = {

  width: "100%",
  padding: "14px",
  borderRadius: "16px",
  border: "none",
  background:"linear-gradient(135deg,#22c55e,#16a34a)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"

};

const retryBtn = {

  width: "100%",
  padding: "14px",
  borderRadius: "16px",
  border: "none",
  background:"linear-gradient(135deg,#ef4444,#dc2626)",
  color: "#fff",
  fontWeight: "bold",
  marginTop: "10px",
  cursor: "pointer"

};

const closeBtn = {

  background: "#ef4444",
  color: "#fff",
  border: "none",
  padding: "10px 16px",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer"

};

const premiumOverlay = {

  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.8)",
  backdropFilter: "blur(10px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 10000

};

const premiumCard = {

  width: "380px",
  background: "#fff",
  padding: "35px",
  borderRadius: "24px",
  textAlign: "center",
  border: "2px dashed #ef4444"

};

const premiumBtn = {

  width: "100%",
  padding: "15px",
  border: "none",
  borderRadius: "14px",
  background:"linear-gradient(135deg,#ef4444,#dc2626)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"

};
